import React from "react";
import { useStore } from "../Context";
import useTheme from "../hooks/useTheme";

function Welcome() {
    const { userName, stepForward, step } = useStore();
    
    const theme = useTheme();
    
    function handleForward () {
        if (step === 4) return;
        stepForward();
    };
    
    return (
        <main className="page-step">
            <header className="page-header">
                <h1 className="text-center text-4xl">¡Te damos la bienvenida, {userName}!</h1>
            </header>
            <div className="page-content self-center">
                <img src={`/${theme}/logo.png`} alt="" width="300" className="image-logo" />
            </div>
            <div className="page-actions flex-column">
                <button className="button-primary" onClick={handleForward}>
                    Ver contrato
                </button>
            </div>
        </main>
    );
}

export default Welcome;
